import { Link } from 'react-router-dom';
import { Globe, Mail } from 'lucide-react';
import { WhatsAppIcon } from './WhatsAppIcon';
import { useLanguage } from '../i18n';
import { Logo } from './Logo';
import { Overline } from './Overline';
import { WHATSAPP_URL } from '../lib/whatsapp';

export const Footer = () => {
  const { t } = useLanguage();

  const links = [
    { to: '/', label: t.nav.home, id: 'home' },
    { to: '/sobre', label: t.nav.about, id: 'about' },
    { to: '/servicos', label: t.nav.services, id: 'services' },
    { to: '/processo', label: t.nav.process, id: 'process' },
    { to: '/faq', label: t.nav.faq, id: 'faq' },
    { to: '/contato', label: t.nav.contact, id: 'contact' },
  ];

  return (
    <footer className="border-t border-graphite-200 bg-graphite" data-testid="footer">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 md:grid-cols-3">
        <div>
          <Logo className="h-9 w-auto" testId="footer-logo" />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-steel">
            {t.footer.tagline}
          </p>
        </div>

        <div>
          <Overline>{t.footer.navTitle}</Overline>
          <ul className="mt-5 space-y-2.5">
            {links.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.id}`}
                  className="text-sm text-steel transition-colors duration-200 hover:text-silver"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <Overline>{t.footer.contactTitle}</Overline>
          <ul className="mt-5 space-y-4 text-sm text-steel">
            <li>
              <a
                href={WHATSAPP_URL(t.whatsappMessage)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-link"
                className="flex items-center gap-3 transition-colors duration-200 hover:text-silver"
              >
                <WhatsAppIcon size={18} className="text-steel-label" />
                {t.contact.whatsappValue}
              </a>
            </li>
            <li>
              <a
                href={`mailto:${t.contact.emailValue}`}
                data-testid="footer-email-link"
                className="flex items-center gap-3 transition-colors duration-200 hover:text-silver"
              >
                <Mail size={18} className="text-steel-label" />
                {t.contact.emailValue}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Globe size={18} className="text-steel-label" />
              {t.contact.locationValue}
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-graphite-200">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-6 py-6 font-mono text-xs text-steel-label sm:flex-row sm:items-center sm:justify-between">
          <span>{t.footer.rights}</span>
          <span>Remoto · BR</span>
        </div>
      </div>
    </footer>
  );
};
